import { createSlice } from "@reduxjs/toolkit";

interface Equipment {
  serialNumber: string;
  make: string;
  modelName: string;
  equipmentStatus?: string;
  returnStatus?: string;
}

interface EquipmentReturnState {
  returnRequired: boolean;
  equipment: Equipment[];
  email: string;
  returnDate: string;
  returnCode: string;
  status: string;
  completedURL: string;
  error: string | null;
  APIStatus: string;
  message: string;
  loading: boolean;
  apiError: boolean;
  orderType: string;
}

const initialState: EquipmentReturnState = {
  returnRequired: false,
  equipment: [],
  email: "",
  returnDate: "",
  returnCode: "",
  status: "",
  completedURL: "",
  error: null,
  APIStatus: "",
  message: "",
  loading: false,
  apiError: false,
  orderType: "",
};

const equipmentReturnSlice = createSlice({
  name: "equipmentReturnDetails",
  initialState,
  reducers: {
    setEquipmentReturnDetails: (state, action) => {
      state.returnRequired = action.payload.returnRequired ?? false;
      state.equipment = action.payload.equipment ?? [];
      state.email = action.payload.email ?? "";
      state.returnDate = action.payload.returnDate ?? "";
      state.completedURL = action.payload.completedURL ?? "";
      state.returnCode = action.payload.returnCode ?? "";
      state.status = action.payload.status ?? "";
      state.error = action.payload.error ?? null;
      state.APIStatus = action.payload.APIStatus ?? "";
      state.message = action.payload.message ?? "";
      state.orderType = action.payload.orderType ?? "";
      state.apiError = action.payload.error === true || action.payload.APIStatus !== 200;
    },
    setEquipmentReturnLoading: (state, action) => {
      state.loading = action.payload;
    },
    setEquipmentReturnApiError: (state, action) => {
      state.apiError = action.payload;
    },
  },
});

export const { setEquipmentReturnDetails, setEquipmentReturnLoading, setEquipmentReturnApiError } =
  equipmentReturnSlice.actions;

export const equipmentReturnReducer = equipmentReturnSlice.reducer;
